import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/icon/qr-unready.png'


const _hoisted_1 = { id: "route" }
const _hoisted_2 = { class: "grid md:grid-cols-2 grid-cols-1 gap-4" }
const _hoisted_3 = {
  key: 0,
  class: ""
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Generate QR Code ")
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "font-semibold  color-blue-grey text-sm" }, " untuk digunakan absensi kurir ", -1)
const _hoisted_7 = { class: "flex items-start mb-4 p-fluid" }
const _hoisted_8 = { class: "p-field mr-1 w-1/2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { for: "maxCategory" }, "Tanggal Mulai", -1)
const _hoisted_10 = { class: "p-inputgroup" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-calendar" })
], -1)
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "p-field ml-1 w-1/2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "maxCategory" }, "Tanggal Berakhir", -1)
const _hoisted_15 = { class: "p-inputgroup" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-calendar" })
], -1)
const _hoisted_17 = {
  key: 0,
  class: "p-error"
}
const _hoisted_18 = { class: "btn-action w-full mt-auto mb-5" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Generate Qr ")
const _hoisted_20 = {
  key: 1,
  class: "flex flex-col justify-center"
}
const _hoisted_21 = {
  class: "flex flex-col h-96",
  id: "printMe"
}
const _hoisted_22 = { class: "mt-2  " }
const _hoisted_23 = { class: "flex flex-row justify-center font-bold text-center" }
const _hoisted_24 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("hr", { class: "m-2" }, null, -1)
const _hoisted_26 = { class: "mt-2  h-auto" }
const _hoisted_27 = {
  class: "flex justify-center",
  id: "printMe"
}
const _hoisted_28 = {
  key: 1,
  src: _imports_0,
  class: "icon-scan-input w-3/6"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("hr", { class: "m-2" }, null, -1)
const _hoisted_30 = {
  key: 0,
  class: "mt-10 "
}
const _hoisted_31 = { class: "flex justify-center text-red-500 cursor-pointer" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "pi pi-print" }),
    /*#__PURE__*/_createTextVNode(" Print QR Code")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_QrcodeVue = _resolveComponent("QrcodeVue")
  const _directive_print = _resolveDirective("print")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      true
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("form", {
              id: "form-voucher-discount",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)), ["prevent"]))
            }, [
              _createVNode(_component_Card, null, {
                title: _withCtx(() => [
                  _hoisted_4,
                  _hoisted_5,
                  _hoisted_6
                ]),
                content: _withCtx(() => [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createVNode("div", _hoisted_10, [
                        _createVNode(_component_Calendar, {
                          id: "startDate",
                          dateFormat: "dd-mm-yy",
                          placeholder: "DD-MM-YYYY",
                          class: "input-primary mt-1",
                          modelValue: _ctx.v$.startDate.$model,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.startDate.$model = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"]),
                        _hoisted_11
                      ]),
                      ((_ctx.v$.startDate.$invalid && _ctx.submitted) || _ctx.v$.startDate.$pending.$response)
                        ? (_openBlock(), _createBlock("small", _hoisted_12, _toDisplayString(_ctx.v$.startDate.required.$message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode("div", _hoisted_15, [
                        _createVNode(_component_Calendar, {
                          id: "endDate",
                          minDate: _ctx.getMinDate(),
                          dateFormat: "dd-mm-yy",
                          placeholder: "DD-MM-YYYY",
                          class: "input-primary mt-1",
                          modelValue: _ctx.v$.endDate.$model,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.endDate.$model = $event)),
                          disabled: ""
                        }, null, 8, ["minDate", "modelValue"]),
                        _hoisted_16
                      ]),
                      ((_ctx.v$.endDate.$invalid && _ctx.submitted) || _ctx.v$.endDate.$pending.$response)
                        ? (_openBlock(), _createBlock("small", _hoisted_17, _toDisplayString(_ctx.v$.endDate.required.$message), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                footer: _withCtx(() => [
                  _createVNode("div", _hoisted_18, [
                    (_ctx.route.meta.permission.write)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          type: "submit",
                          form: "form-voucher-discount",
                          class: "font-semibold p-button-danger px-10 mr-2 rounded-lg"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ], 32)
          ]))
        : _createCommentVNode("", true),
      true
        ? (_openBlock(), _createBlock("div", _hoisted_20, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => []),
              content: _withCtx(() => [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", null, [
                        _createTextVNode(_toDisplayString(_ctx.dataForm.startDate ? _ctx.dataForm.startDate :'..') + " s/d " + _toDisplayString(_ctx.dataForm.endDate ? _ctx.dataForm.endDate :'..') + " ", 1),
                        _hoisted_24,
                        _createTextVNode(" " + _toDisplayString(_ctx.agentData.NamaAgen) + " - " + _toDisplayString(_ctx.agentData.NamaKota), 1)
                      ])
                    ])
                  ]),
                  _hoisted_25,
                  _createVNode("div", _hoisted_26, [
                    _createVNode("div", _hoisted_27, [
                      (_ctx.Qrvalue)
                        ? (_openBlock(), _createBlock(_component_QrcodeVue, {
                            key: 0,
                            value: _ctx.Qrvalue,
                            size: _ctx.Qrsize,
                            level: "H"
                          }, null, 8, ["value", "size"]))
                        : (_openBlock(), _createBlock("img", _hoisted_28))
                    ])
                  ]),
                  _hoisted_29
                ])
              ]),
              footer: _withCtx(() => [
                (_ctx.showBtnPrint && _ctx.route.meta.permission.update)
                  ? (_openBlock(), _createBlock("div", _hoisted_30, [
                      _withDirectives(_createVNode("div", _hoisted_31, [
                        _hoisted_32
                      ], 512), [
                        [_directive_print, _ctx.printWQr()]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}